import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import Text from '../../../../../components/Text';
import MdroInfo from '../../../../../components/MdroInfo';
import CmsAlert, { CMS_ALERT_ICON_VARIANT } from '../../../../../components/CmsAlert';
import { TraumaticStatus, TransportMode } from '../../../../../components/TableStatus';
import { isNotEmptyArray } from '../../../../../utils/newBedStatusUtil';
import { bedP } from '../../../../BedStatus/bsApp';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: '0.75rem',
    color: '#538FFF',
    textTransform: 'uppercase',
    fontFamily: 'NotoSans-Bold',
    lineHeight: '1.25rem',
    whiteSpace: 'nowrap',
  },
  data: {
    color: '#2E4469',
    fontSize: '0.875rem',
    whiteSpace: 'pre-line',
  },
}));

const OtherInfo = ({ rowData }) => {
  const classes = useStyles();
  const infoMap = [
    {
      title: 'mdro / CMS Alert',
      data: rowData?.[bedP?.mdroInfo],
      type: 'mdro',
      flexBasis: '20%',
    },
    {
      title: 'covid',
      data: rowData?.covidInfo,
      type: 'covid',
      flexBasis: '15%',
    },
    {
      title: 'ISO.ROOM',
      data: rowData?.isolationRoom,
      type: 'iso',
      flexBasis: '15%',
    },
    {
      title: 'Trauma type',
      data: rowData?.traumaType,
      type: 'traumaType',
      flexBasis: '15%',
    },
    {
      title: 'cxr',
      data: rowData?.cxrInfos,
      type: 'cxr',
      flexBasis: '40%',
    },
    {
      title: 'tocc',
      data: rowData?.tocc,
      type: 'text',
      flexBasis: '10%',
    },
    {
      title: 'OXygen req.',
      data: rowData?.oxygenReq,
      type: 'text',
      flexBasis: '10%',
    },
    {
      title: 'special alert',
      data: rowData?.specialAlert,
      type: 'specialAlert',
      flexBasis: '30%',
    },
    {
      title: 'Amb Status',
      data: rowData?.ambStatus,
      type: 'ambStatus',
      flexBasis: '17%',
    },
    {
      title: 'discharged remark@eaed',
      data: rowData?.dischargeRemark,
      type: 'dischargeRemark',
      flexBasis: '40%',
    },
  ];

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      p="0.5rem"
      width="100%"
      bgcolor="rgb(255, 251, 248)"
      gridGap="2rem"
    >
      {infoMap.map((item) => (
        <Box display="flex" flexDirection="column" flexBasis={item.flexBasis} key={item.title}>
          <Box className={classes.title}>{item.title}</Box>
          {item.type === 'text' && <div className={classes.data}>{item.data ?? '--'}</div>}
          {item.type === 'iso' &&
            (item.data ? (
              <Box display="flex">
                <Box bgcolor="#FECA06" padding="0.357rem 0.571rem" borderRadius="0.357rem">
                  <div className={classes.data}>{item.data}</div>
                </Box>
              </Box>
            ) : (
              <div className={classes.data}>--</div>
            ))}
          {item.type === 'cxr' && (
            <Box className={classes.data} display="flex" flexDirection="column" gridGap="0.5rem">
              {item.data?.length > 0
                ? item.data?.map((item) => (
                    <div key={`${item.gcrName}:${item.gcrContent}`}>{`${item.gcrName}:${item.gcrContent}`}</div>
                  ))
                : '--'}
            </Box>
          )}
          {item.type === 'specialAlert' && (
            <Text color="#B92B21" fontSize="1.1rem">
              {item.data ?? '--'}
            </Text>
          )}
          {item.type === 'dischargeRemark' && (
            <Text color="#B92B21" fontSize="0.875rem">
              {item.data ?? '--'}
            </Text>
          )}
          {item.type === 'covid' &&
            (item.data ? (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                p="0.5rem"
                bgcolor="#FAE5E5"
                borderRadius="0.25rem"
              >
                <Text color="#B92B21" fontSize="0.75rem">
                  {`${item.data?.lab}:${item.data?.value}`}
                </Text>
              </Box>
            ) : (
              '--'
            ))}
          {item.type === 'mdro' && (
            <Box display="flex" flexWrap="wrap" gridGap="0.62rem">
              {isNotEmptyArray(item.data) || isNotEmptyArray(rowData?.[bedP?.cmsAlertInfos]) ? (
                <>
                  {item.data?.map((item) => (
                    <MdroInfo content={item.alertDesc} key={item.alertDesc} popValue={item} />
                  ))}
                  <CmsAlert alertsData={rowData?.[bedP?.cmsAlertInfos]} variant={CMS_ALERT_ICON_VARIANT.WIDE} />
                </>
              ) : (
                '--'
              )}
            </Box>
          )}
          {item.type === 'traumaType' && <TraumaticStatus traumaType={item.data} />}
          {item.type === 'ambStatus' && <TransportMode type={item.data} />}
        </Box>
      ))}
    </Box>
  );
};

export default OtherInfo;
